export default  {
  bindings: {
    targetuser: '=',
    hotels: '<'
  },
  controller: 'userFormController',
  template: require('../views/user.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/components/user.form.component.js